import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'sm-email-content-viewer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="email-content-viewer">
      <div class="email-content-frame" [innerHTML]="sanitizedContent"></div>
    </div>
  `,
  styles: [
    `
      .email-content-viewer {
        max-height: 500px;
        overflow-y: auto;
        border: 1px solid #e0e0e0;
        border-radius: 8px;
        background: #f9f9f9;
      }
      .email-content-frame {
        padding: 20px;
        background: white;
        margin: 10px;
        border-radius: 4px;
        max-width: 100%;
        overflow-x: auto;
      }
      .email-content-frame ::ng-deep img {
        max-width: 100%;
        height: auto;
      }
      .email-content-frame ::ng-deep table {
        max-width: 100%;
      }
      .email-content-frame ::ng-deep * {
        font-family: Arial, Helvetica, sans-serif !important;
      }
    `,
  ],
})
export class EmailContentViewerComponent {
  @Input() content = '';

  constructor(private sanitizer: DomSanitizer) {}

  get sanitizedContent(): SafeHtml {
    // Remove external CSS links and other problematic elements
    const cleanedContent = this.cleanHtmlContent(this.content);
    return this.sanitizer.bypassSecurityTrustHtml(cleanedContent);
  }

  private cleanHtmlContent(html: string): string {
    if (!html) return '';

    // Create a temporary div to parse the HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    // Remove external CSS links
    const linkElements = tempDiv.querySelectorAll('link[rel="stylesheet"]');
    linkElements.forEach(link => link.remove());

    // Remove script tags
    const scriptElements = tempDiv.querySelectorAll('script');
    scriptElements.forEach(script => script.remove());

    // Remove base tags
    const baseElements = tempDiv.querySelectorAll('base');
    baseElements.forEach(base => base.remove());

    // Remove meta tags
    const metaElements = tempDiv.querySelectorAll('meta');
    metaElements.forEach(meta => meta.remove());

    // Remove head and body tags, keep their content
    const headElement = tempDiv.querySelector('head');
    if (headElement) {
      while (headElement.firstChild) {
        tempDiv.appendChild(headElement.firstChild);
      }
      headElement.remove();
    }

    const bodyElement = tempDiv.querySelector('body');
    if (bodyElement) {
      while (bodyElement.firstChild) {
        tempDiv.appendChild(bodyElement.firstChild);
      }
      bodyElement.remove();
    }

    // Remove html tag, keep its content
    const htmlElement = tempDiv.querySelector('html');
    if (htmlElement) {
      while (htmlElement.firstChild) {
        tempDiv.appendChild(htmlElement.firstChild);
      }
      htmlElement.remove();
    }

    return tempDiv.innerHTML;
  }
}
